import { useTranslation } from "react-i18next";
import moment from "moment";

/**
 * * Format duration between two moments
 */
export function useDurationFormatter() {
    const { t } = useTranslation();

    const formatDuration = (startTime: moment.Moment, endTime: moment.Moment): string => {
        const durationMinutes = endTime.diff(startTime, "minutes");
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;

        if (hours > 0) {
            if (minutes > 0) {
                return t("duration.hoursAndMinutes", { hours, minutes });
            } else {
                return t("duration.onlyHours", { hours });
            }
        } else {
            return t("duration.onlyMinutes", { minutes });
        }
    };

    return formatDuration;
}
